// extracted by mini-css-extract-plugin
export default {"container":"mGT4aE","content":"MGJ6y9"};